import React from "react";
import { Modal } from "react-bootstrap";
import WebhookCommon from "../../common-component/WebhookCommon";

function WebhookCommonModal(props) {
  return (
    <>
      <Modal
        {...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">Webhook</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <WebhookCommon
            hooktype={props?.hooktype}
            associationid={props?.associationid}
            associationtype={props?.associationtype}
          />
        </Modal.Body>
      </Modal>
    </>
  );
}

export default WebhookCommonModal;
